<template>
  <footer class="footer">
    <div class="container">
      <span class="footer-text">
        Meu Ateliê v{{ version }}
      </span>
    </div>
  </footer>
</template>

<script>
import { version } from '../../package.json'

export default {
  name: 'PageFooter',
  data() {
    return {
      version: version
    }
  }
}
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f8f9fa;
  padding: 10px 0;
  border-top: 1px solid #e7e7e7;
}

.footer-text {
  color: #6c757d;
  font-size: 0.9rem;
}

.container {
  text-align: center;
}
</style>